import React, { useContext, useEffect } from "react";
import { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Context } from "../../utils/context";
import { Line } from "react-chartjs-2";
import Chart from "chart.js/auto";
import { useParams } from "react-router-dom";
import "./singleCustomer.css";
import Summary from "./Summary";

const SingleCustomerTranscript = () => {
  const id = useParams().id;
  const { setHeading } = useContext(Context);
  const [data, setData] = useState("");

  useEffect(() => {
    setHeading("Emotion Analysis");
    fetch(`http://api.realtalk.reallytics.ai/final-data/transcript/${id}`)
      .then((res) => res.json())
      .then((resJson) => setData(resJson))
      .catch((error) => console.log(error));
  }, [id, setHeading]);

  const topics = data.Top5Topics
    ? data.Top5Topics[0].replace(/'s/g, "").replace(/'/g, '"')
    : null;
  const topicsJson = JSON.parse(topics);

  const [expandedAccordion, setExpandedAccordion] = useState(null);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : null);
  };

  const datas = {
    labels: [
      "Anger",
      "Sadness",
      "Excitement",
      "Satisfaction",
      "Empathy",
      "Friendliness",
      "Admiration",
      "Understanding",
      "Engagement",
      "Stress",
      "Confidence",
      "Professionalism",
    ],
    datasets: [
      {
        label: "Agent",
        backgroundColor: "#029CD4",
        borderColor: "#029CD4",
        borderWidth: 3,
        hoverBackgroundColor: "#029CD4",
        hoverBorderColor: "#029CD4",
        data: [
          data.Agent_Anger,
          data.Agent_Sadness,
          data.Agent_Excitement,
          data.Agent_Satisfaction,
          data.Agent_Empathy,
          data.Agent_Friendliness,
          data.Agent_Admiration,
          data.Agent_Understanding,
          data.Agent_Engagement,
          data.Agent_Stress,
          data.Agent_Confidence,
          data.Agent_Professionalism,
        ],
      },
      {
        label: "Customer",
        backgroundColor: "#0052D9",
        borderColor: "#0052D9",
        borderWidth: 3,
        hoverBackgroundColor: "#0052D9",
        hoverBorderColor: "#0052D9",
        data: [
          data.Customer_Anger,
          data.Customer_Sadness,
          data.Customer_Excitement,
          data.Customer_Satisfaction,
          data.Customer_Empathy,
          data.Customer_Friendliness,
          data.Customer_Admiration,
          data.Customer_Understanding,
          data.Customer_Engagement,
          data.Customer_Stress,
          data.Customer_Confidence,
          data.Customer_Professionalism,
        ],
      },
    ],
  };

  const options = {
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false, // Remove x-axis grid lines
        },
      },
      y: {
        grid: {
          display: false, // Remove y-axis grid lines
        },
      },
    },
    legend: {
      display: false, // Remove the legend
    },
    type: "line",
  };

  return (
    <>
      {/* Bar Graph */}
      <div className="analysis">
        <div className="customerHead ">
          <Line
            data={datas}
            width={null}
            height={null}
            options={options}
            style={{ maxHeight: "50vh" }}
          />
        </div>

        <div className="customerData">
          <Summary title="Executive Summary" data={data?.summary} />

          <div className="accordian">
            <h3>Top Topics</h3>
            <div className="line"></div>
            <div className="item">
              {Object.keys(topicsJson ? topicsJson : "")?.map(
                (result, index) => {
                  const isExpanded = expandedAccordion === `panel${index + 1}`;
                  return (
                    <Accordion
                      key={index}
                      expanded={isExpanded}
                      onChange={handleAccordionChange(`panel${index + 1}`)}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel-content"
                        id={`panel${index + 1}-header`}
                      >
                        <Typography>{result}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          {topicsJson ? topicsJson[result] : ""}
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  );
                }
              )}
            </div>
          </div>
        </div>

        <div className="diarizationHeading">
          <h2>Diarization</h2>
        </div>
        <div className="diarization">
          <Summary title={"Agent Side"} data={data?.Agent_diarized} />
          <Summary title={"Customer Side"} data={data?.Customer_diarized} />
        </div>
        <div className="diarizationHeading">
          <h2>Key Report</h2>
        </div>
        <div className="diarization">
          <Summary title="Guideline" data={data?.Guidelines} />
          <Summary
            title="Agent Performance Report"
            data={data?.AgentPerformanceReport}
          />
        </div>
      </div>
    </>
  );
};

export default SingleCustomerTranscript;
